import React from "react";
import { connect } from "react-redux";
import { PlusOutlined } from '@ant-design/icons';
import { Empty, Button } from "antd";
import * as R from "ramda";
import CheckList from "./CheckList";
import CheckDetail from "./CheckDetail";
import Loading from "./Loading";
import PopUp from "./PopUp";
import AddMonitor from "./AddMonitor";
import MonitorImg from "../assets/images/monitoring-check.svg";
import "../styles/components/page.scss";

class Page extends React.Component {
  state = {
    isMobile: false
  };

  throttledHandleWindowResize = () => {
    this.setState(() => ({ isMobile: window.innerWidth < 850 }));
  };

  componentDidMount() {
    this.setState(() => ({ isMobile: window.innerWidth < 850 }));
    window.addEventListener("resize", this.throttledHandleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.throttledHandleWindowResize);
  }

  addMonitor = () => {
    this.setState(prevState => ({ addNew: !prevState.addNew }));
  };

  onAddClose = () => {
    this.setState(prevState => ({ addNew: !prevState.addNew }));
  };

  render() {
    let jsx = (
      <div className="check-detail__nothing">
        <Empty />
      </div>
    );
    let loaderJsx = undefined;
    if (this.props.hasCheck) {
      jsx = <CheckDetail id={this.props.match.params.id} />;
    }
    if (this.props.fetchInProgress) {
      loaderJsx = <Loading />;
    }

    return (
      <div className="dashboard">
        {R.gt(R.length(this.props.checks), 0) ? (
          <>
            {this.state.isMobile ? (
              this.props.match.params.id ? (
                undefined
              ) : (
                <CheckList activeCheckId={this.props.match.params.id} />
              )
            ) : (
              <CheckList activeCheckId={this.props.match.params.id} />
            )}
            {this.state.isMobile ? (
              this.props.match.params.id ? (
                <div className="page">{jsx}</div>
              ) : (
                undefined
              )
            ) : (
              <div className="page">{jsx}</div>
            )}
            {loaderJsx}
          </>
        ) : (
          <div className="no-monitor">
            <img src={MonitorImg} alt="No Monitor" />
            <h2>No Monitors</h2>
            <h4>
              You have no monitors in your list.
              <br />
              Please add a new monitor
            </h4>
            <Button
              className="btn-addNew"
              onClick={this.addMonitor}
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
            >
              Add Monitor
            </Button>
            {this.state.addNew && (
              <PopUp closePopUp={this.onAddClose} closeOnOutClick={false}>
                <AddMonitor key={"form-add"} />
              </PopUp>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const selectedId = parseInt(props.match.params.id);
  const hasCheck = R.any(R.propEq("id", selectedId), state.checks);
  return {
    fetchInProgress: state.fetchInProgress,
    hasCheck,
    checks: state.checks
  };
};

export default connect(mapStateToProps)(Page);
